import React from 'react';
import { Calendar, Clock, MapPin, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import '../styles/SchedulesPage.css';

const marketsData = [
  {
    id: 1,
    name: "Logan Square Farmers Market",
    season: "2026 Outdoor Season",
    day: "Sunday",
    dates: ["5/31", "6/7", "6/14", "6/21", "6/28", "7/5", "7/12", "7/19", "7/26", "8/2", "8/9", "8/16", "8/23", "8/30", "9/6", "9/13", "9/20", "9/27", "10/4", "10/11", "10/18", "10/25"],
    time: "8:30 AM - 3:00 PM",
    color: "blue"
  },
  {
    id: 2,
    name: "Wicker Park Farmers Market",
    season: "2026 Outdoor Season",
    day: "Sunday",
    dates: ["6/7", "6/21", "7/5", "7/19", "8/2", "8/16", "8/30", "9/13", "9/27"],
    time: "8:00 AM - 2:00 PM",
    color: "purple"
  },
  {
    id: 3,
    name: "61st Street Farmers Market",
    season: "2026 Outdoor Season",
    day: "Saturday",
    dates: ["5/30", "6/6", "6/13", "6/20", "6/27", "7/4", "7/11", "7/18", "7/25", "8/1", "8/8", "8/15", "8/22", "8/29", "9/5", "9/12", "9/19", "9/26", "10/3", "10/10", "10/17", "10/24", "10/31"],
    time: "9:00 AM - 2:00 PM",
    color: "green"
  },
  {
    id: 4,
    name: "Chicago Vegan Farmers Market",
    location: "Skinner Park",
    season: "2026 Season",
    day: "Friday",
    dates: ["7/10", "7/17", "7/24", "7/31", "8/7", "8/14", "8/21", "8/28", "9/4", "9/11", "9/18", "9/25"],
    time: "4:00 PM - 8:00 PM",
    color: "pink",
    featured: true
  }
];

const SchedulesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="schedules-page">
      <div className="schedules-container">
        <Button 
          onClick={() => navigate('/')}
          className="back-button"
          variant="outline"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Button>

        <div className="schedules-header">
          <h1>🧺 Farmers Market Schedules</h1>
          <p>Find BOT Bakery at these amazing Chicago farmers markets in 2026!</p>
        </div>

        <div className="markets-grid">
          {marketsData.map((market) => (
            <div key={market.id} className={`market-card market-${market.color} ${market.featured ? 'featured' : ''}`}>
              {market.featured && (
                <div className="featured-badge">
                  ⭐ Featured Market
                </div>
              )}
              
              <div className="market-header">
                <h2>{market.name}</h2>
                {market.location && <p className="market-location">{market.location}</p>}
                <p className="market-season">{market.season}</p>
              </div>

              <div className="market-info">
                <div className="info-row">
                  <Calendar className="h-5 w-5" />
                  <span><strong>{market.day}s</strong></span>
                </div>
                <div className="info-row">
                  <Clock className="h-5 w-5" />
                  <span>{market.time}</span>
                </div>
              </div>

              <div className="dates-section">
                <h3>📅 {market.dates.length} Market Dates:</h3>
                <div className="dates-grid">
                  {market.dates.map((date, index) => (
                    <div key={index} className="date-badge">
                      {date}
                    </div>
                  ))}
                </div>
              </div>

              {market.featured && (
                <div className="featured-note">
                  <p>✨ Featuring BOT Bakery and dozens of other vegan vendors!</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="schedules-footer">
          <div className="footer-card">
            <h3>🧁 What to Expect</h3>
            <p>Find our full selection of vegan, gluten-free cupcakes, cookies, breads, and seasonal specialties at each market!</p>
          </div>
          
          <div className="footer-card">
            <h3>📞 Questions?</h3>
            <p>Call or text Betty at <strong>773-495-4615</strong></p>
            <p>Email: <a href="mailto:bettyalper@gmail.com">bettyalper@gmail.com</a></p>
          </div>

          <div className="footer-card">
            <h3>💡 Pro Tip</h3>
            <p>Arrive early for the best selection! Popular items sell out quickly.</p>
          </div>
        </div>

        <div className="cta-section">
          <h2>Can't make it to the market?</h2>
          <p>Order cupcakes for delivery or catering!</p>
          <Button 
            onClick={() => navigate('/order')}
            className="order-cta"
            size="lg"
          >
            Order Cupcakes Online
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SchedulesPage;
